var Shopify = Shopify || {};

Shopify.money_format = window.cartStrings.money_format || "£{{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class MainBundle extends HTMLElement {
  perkProductChangeEvents = ["bundle:free-product-added", "bundle:free-product-quantity:changed"];
  constructor() {
    super();
    this.data = {
      products: [],
      gift_products: [],
      limit: parseInt(this.dataset.limit) || 8,
      current: 0,
      gift_limit: 0
    };
  }

  connectedCallback() {
    this.footer = this.querySelector("bundle-footer");
    this.progress = this.querySelector(".bundle-progress-bar");
    this.progress_steps = this.querySelector(".progress-steps");
    this.progressStatus = this.querySelector(".bundle-progress-status");
    this.quantityChangers = this.querySelectorAll(".product-add-to-cart, .quantity-changer");
    const tabsCount = document.querySelectorAll(".custom-tier-tab").length;
    this.data.gift_limit = tabsCount > 0 ? tabsCount : 1;
    this.addEventListener("bundle:product-added", this.updateProductList.bind(this));
    this.addEventListener("bundle:quantity:changed", this.updateProductList.bind(this));
    this.perkProductChangeEvents.forEach((event) => this.addEventListener(event, this.updatePerkProductList.bind(this)));
    document.documentElement.addEventListener("bundle:clear", this.clearBundle.bind(this));
  }

  updateProductList({ detail: { product, quantity } }) {
    const productIndex = this.data.products.findIndex((p) => p.id === product.id);
    let currentTotalQuantity = this.data.products.reduce((sum, p) => sum + p.quantity, 0);

    if (quantity === 0) {
      if (productIndex !== -1) {
        currentTotalQuantity -= this.data.products[productIndex].quantity
        this.data.products.splice(productIndex, 1);
      }
    } else if (productIndex > -1) {
      const oldQuantity = this.data.products[productIndex].quantity;
      const newQuantity = Math.min(quantity, this.data.limit - (currentTotalQuantity - oldQuantity));
      currentTotalQuantity = currentTotalQuantity - oldQuantity + newQuantity;
      this.data.products[productIndex].quantity = newQuantity;
    } else if (quantity > 0) {
      this.data.products.push({ ...product, quantity });
      currentTotalQuantity += quantity;
    }

    // const isLimitReached = currentTotalQuantity >= this.data.limit;
    // this.querySelectorAll(".quantity-changer.add, .product-add-to-cart").forEach((button) => {
    //   button.disabled = isLimitReached;
    // });

    this.footer?.renderPrice(this.data.products);
    this.footer?.renderMiniCart(this.data);
    this.footer?.updateNextButton(this.data.products);

    const progressBarTitles = window.bundle_progress_bar_settings.titles;
    const title_1 = Number(progressBarTitles.title_1.amount * 100);
    const title_2 = Number(progressBarTitles.title_2.amount * 100);
    const title_3 = Number(progressBarTitles.title_3.amount * 100);
    const totalAmount = this.data.products.reduce((sum, p) => sum + p.price * p.quantity, 0);

    // Each milestone sits at one third of the visual track. This keeps the
    // progress marker aligned with the £40, £70 and £100 reward labels.
    const calculateProgressValue = (amount) => {
      if (amount < title_1) return (amount / title_1) * (100 / 3);
      if (amount < title_2) return (100 / 3) + ((amount - title_1) / (title_2 - title_1)) * (100 / 3);
      if (amount < title_3) return (200 / 3) + ((amount - title_2) / (title_3 - title_2)) * (100 / 3);
      return 100;
    };

    const progressValue = calculateProgressValue(totalAmount);
    let trackProgress = 0;
    const secondTierTrackPoint = 222 / 324;
    if (totalAmount >= title_1 && totalAmount < title_2) {
      trackProgress = ((totalAmount - title_1) / (title_2 - title_1)) * secondTierTrackPoint;
    } else if (totalAmount >= title_2 && totalAmount < title_3) {
      trackProgress = secondTierTrackPoint + ((totalAmount - title_2) / (title_3 - title_2)) * (1 - secondTierTrackPoint);
    } else if (totalAmount >= title_3) {
      trackProgress = 1;
    }
    this.progress_steps.style.setProperty("--bundle-progress-scale", String(trackProgress));
    const steps = this.progress_steps.children;
    const activeSteps = [
      totalAmount >= title_1,
      totalAmount >= title_2,
      totalAmount >= title_3
    ];

    Array.from(steps).forEach((step, index) => {
      if (activeSteps[index]) {
        step.classList.add("active");
      } else {
        step.classList.remove("active");
      }
    });

    this.progress.value = progressValue;
    if (this.progressStatus) {
      const tiers = [
        { amount: title_1, reward: progressBarTitles.title_1.title },
        { amount: title_2, reward: progressBarTitles.title_2.title },
        { amount: title_3, reward: progressBarTitles.title_3.title }
      ];
      const nextTier = tiers.find((tier) => totalAmount < tier.amount);
      this.progressStatus.textContent = nextTier
        ? `Add ${Shopify.formatMoney(nextTier.amount - totalAmount, Shopify.money_format)} more to unlock ${nextTier.reward}.`
        : `Bundle complete — you have unlocked ${progressBarTitles.title_3.title}.`;
    }
    this.querySelectorAll('.bundle-collection-tab.hidden').forEach((tab) => {
      tab.removeAttribute('data-index');
    })
    this.querySelectorAll('.bundle-collection-tab.js-bundle-tab').forEach((tab, index) => {
      tab.setAttribute('data-index', index);
    })
  }

  updatePerkProductList({ detail: { product, quantity } }) {
    const productIndex = this.data.gift_products.findIndex((p) => p.id === product.id);
    let currentTotalQuantity = this.data.gift_products.reduce((sum, p) => sum + p.quantity, 0);

    if (quantity === 0) {
      if (productIndex !== -1) {
        currentTotalQuantity -= this.data.gift_products[productIndex].quantity;
        this.data.gift_products.splice(productIndex, 1);
      }
    } else if (quantity > 0) {
      // Enforce gift limit
      if (currentTotalQuantity >= this.data.gift_limit) {
        // Do not add more than allowed
      } else {
        this.data.gift_products.push({ ...product, quantity: 1 });
      }
    }

    this.footer?.renderPerksCart(this.data);
  }

  clearBundle() {
    this.data.products = [];
    this.data.gift_products = [];
    this.footer.renderPrice([]);
    this.footer.renderMiniCart({ products: [], limit: this.data.limit });
    this.footer.renderPerksCart(this.data);
    this.progress.value = 0;
    this.progress_steps.style.setProperty("--bundle-progress-scale", "0");
    if (this.progressStatus) this.progressStatus.textContent = "Add products to unlock bundle savings.";
    this.querySelectorAll(".quantity-changer.add, .product-add-to-cart").forEach((button) => {
      button.disabled = false;
    });
    this.querySelectorAll(".progress-step").forEach((step) => {
      step.classList.remove('active');
    });
    this.footer.resetNextAndCheckoutLayout();
    this.footer.clearToInitialStep();
  }
}
customElements.define("main-bundle", MainBundle);

class ProductsContainer extends HTMLElement {
  connectedCallback() {
    this.collectionTabs = this.querySelectorAll(".bundle-collection-tab");
    this.collectionTabContents = this.querySelectorAll(".bundle-tab-content");
    this.collectionTabs.forEach((tab) =>
      tab.addEventListener("click", this.handleTabChange.bind(this))
    );

    this.tabChangers = this.querySelectorAll(".button-navigation");
    this.tabChangers.forEach((tabChanger) =>
      tabChanger.addEventListener("click", this.handleTabNav.bind(this))
    );
  }

  handleTabNav({ currentTarget }) {
    this.collectionTabsIndex = this.querySelectorAll(".bundle-collection-tab[data-index]");
    const direction = currentTarget.dataset.nav;
    const currentActiveTab = this.querySelector(".bundle-collection-tab.active");
    const currentIndex = parseInt(currentActiveTab.dataset.index);
    const totalIndex = this.collectionTabsIndex.length;
    let newIndex = 0
    if (direction === 'next') {
      newIndex = currentIndex + 1 >= totalIndex ? 0 : currentIndex + 1;
    } else {
      newIndex = currentIndex - 1 === -1 ? totalIndex - 1 : currentIndex - 1;
    }
    this.collectionTabsIndex[newIndex].click();
  }

  handleTabChange({ target }) {
    this.collectionTabs.forEach((tab) => tab.classList.toggle("active", tab === target));
    this.collectionTabContents.forEach((content) => content.classList.remove("active"));
    this.querySelector(`[data-tab='${target.dataset.target}']`)?.classList.add("active");
  }
}
customElements.define("products-container", ProductsContainer);

class BundleProduct extends HTMLElement {

  constructor() {
    super();
    this.data = {
      limit: parseInt(this.dataset.limit) || 8
    };
  }
  connectedCallback() {
    const productDataEl = this.querySelector(".product-data");
    if (!productDataEl) throw new Error("Product data is required!");
    this.productData = JSON.parse(productDataEl.textContent);
    this.setAttribute('data-product-id', this.productData.id);
  }

  dispatchBundleEvent(eventType, detail) {
    this.closest("main-bundle")?.dispatchEvent(
      new CustomEvent(eventType, { detail: { ...detail, product: this.productData }, bubbles: true })
    );
  }
}
customElements.define("bundle-product", BundleProduct);

class QuantitySelector extends HTMLElement {
  connectedCallback() {
    document.documentElement.addEventListener("bundle:clear", this.clearBundle.bind(this));
    this.quantityInput = this.querySelector(".quantity-input");
    this.querySelectorAll(".quantity-changer").forEach((changer) =>
      changer.addEventListener("click", this.handleQuantityChange.bind(this))
    );

    this.querySelector(".product-add-to-cart")?.addEventListener("click", this.handleAddToCart.bind(this));
  }

  handleQuantityChange({ currentTarget }) {
    const action = currentTarget.dataset.action;
        let quantity = parseInt(this.quantityInput.value);
        if (this.classList.contains("is-free-gift-product")) {
            if (action === 'increment') return;
            if (action === 'decrement') {
                quantity = Math.max(0, quantity - 1);
                // this.closest(".bundle-tab-content").querySelectorAll(".quantity-changer.add").forEach((changer) => changer.disabled = false);
            }
            this.closest("bundle-product")?.dispatchBundleEvent("bundle:free-product-quantity:changed", { quantity });
        } else {
            if (action === 'increment') {
                quantity = quantity + 1;
            } else {
                quantity = Math.max(0, quantity - 1);
            }
            this.closest("bundle-product")?.dispatchBundleEvent("bundle:quantity:changed", { quantity });
        }

        this.classList.toggle("added-to-cart", quantity > 0);
        this.quantityInput.value = quantity;
  }

  handleAddToCart({ currentTarget }) {
    if (this.classList.contains("is-free-gift-product")) {
      const mainBundle = this.closest("main-bundle");
      const data = mainBundle.data;
      const currentGiftQty = data.gift_products.reduce((sum, p) => sum + p.quantity, 0);
      if (currentGiftQty >= data.gift_limit) return;
      this.quantityInput.value = 1;
      this.classList.add("added-to-cart");
      this.closest("bundle-product")?.dispatchBundleEvent("bundle:free-product-added", { quantity: 1 });
    } else {
      this.quantityInput.value = 1;
      this.classList.add("added-to-cart");
      this.closest("bundle-product")?.dispatchBundleEvent("bundle:product-added", { quantity: 1 });
    }
  }

  clearBundle() {
    this.quantityInput.value = 0;
    this.classList.remove("added-to-cart");
  }
}
customElements.define("quantity-selector", QuantitySelector);

class BundleFooter extends HTMLElement {

  constructor() {
    super();
    this.closeSvg = `<svg class="icon icon-close" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.99905 6.28684L13.9988 0.287109L15.713 2.0013L9.71323 8.00102L15.713 14.0007L13.9988 15.7148L7.99905 9.71521L1.99936 15.7148L0.285156 14.0007L6.28487 8.00102L0.285156 2.0013L1.99936 0.287109L7.99905 6.28684Z" fill="black"/></svg>`
    this.plusSvg = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M7.75 7.75V0.25H10.25V7.75H17.75V10.25H10.25V17.75H7.75V10.25H0.25V7.75H7.75Z" fill="black"/> </svg>`;
    this.showMoreLabel = "Show more";
    this.showLessLabel = "Show less";
    this.data = {
      limit: parseInt(this.dataset.limit) || 8
    };
  }
  connectedCallback() {
    this.discountPriceElement = this.querySelector(".bundle-selection-total-discount");
    this.priceElement = this.querySelector(".bundle-selection-total-price");
    this.clearButton = this.querySelector(".bundle-selection-clear");
    this.backButton = this.querySelector(".bundle-selection-back");
    this.nextButton = this.querySelector(".bundle-selection-next");
    this.checkoutButton = this.querySelectorAll(".bundle-selection-checkout");
    this.showMoreBtn = this.querySelector(".show-more");
    this.showMoreBtn.addEventListener("click", this.toggleShowMore.bind(this));
    this.clearButton.addEventListener("click", this.clearSelection.bind(this));
    this.checkoutButton.forEach((button) => button.addEventListener("click", this.checkout.bind(this)));
    this.backButton.addEventListener("click", this.secondStep.bind(this));
    this.nextButton.addEventListener("click", this.secondStep.bind(this));
    this.querySelector('.bundle-items').addEventListener('click', (e) => {
      const removeButton = e.target.closest('.js-remove-item');
      if (removeButton) {
        const bundleItem = removeButton.closest('.bundle-item');
        const itemIndex = Array.from(bundleItem.parentElement.children).indexOf(bundleItem);
        this.handleItemRemoval(itemIndex);
      }
    });
  }

  toggleShowMore() {
    this.querySelector(".bundle-items").classList.toggle("active");
    if (this.querySelector(".bundle-items").classList.contains("active")) {
      this.showMoreBtn.querySelector(".show-text").innerHTML = this.showLessLabel;
    } else {
      this.showMoreBtn.querySelector(".show-text").innerHTML = this.showMoreLabel;
    }
  }

  updateNextButton(products) {
    const firstStep = this.querySelector(".first-step");
    const firstCheckoutButton = firstStep.querySelector(".bundle-selection-checkout");
    const currentTotalQuantity = products.length;
    if(currentTotalQuantity > 0){
      this.nextButton.disabled = false;
      firstCheckoutButton.disabled = false;
    } else {
      this.nextButton.disabled = true;
      firstCheckoutButton.disabled = true;
    }
    const totalPrice = this.closest("main-bundle").data.products.reduce((sum, p) => sum + p.price * p.quantity, 0) / 100;
    const freeGiftProductQuantity = window.bundle_progress_bar_settings.free_gift_product_quantity.totalPrice;
    if(totalPrice >= freeGiftProductQuantity){
      firstCheckoutButton.classList.add("hidden");
      this.nextButton.classList.remove("hidden");
    } else{
      firstCheckoutButton.classList.remove("hidden");
      this.nextButton.classList.add("hidden");
    }
  }

  renderPrice(products) {
    const discountPrice = products.reduce((sum, p) => sum + p.compare_at_price * p.quantity, 0);
    const price = products.reduce((sum, p) => sum + p.price * p.quantity, 0);
    if(this.discountPriceElement) this.discountPriceElement.textContent = Shopify.formatMoney(discountPrice, Shopify.money_format);
    this.priceElement.textContent = Shopify.formatMoney(price, Shopify.money_format);
  }

  renderMiniCart(data) {
    const bundleItemsContainer = this.querySelector(".bundle-items");
    bundleItemsContainer.innerHTML = "";

    const close_icon = `<svg class="icon icon-close" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.99905 6.28684L13.9988 0.287109L15.713 2.0013L9.71323 8.00102L15.713 14.0007L13.9988 15.7148L7.99905 9.71521L1.99936 15.7148L0.285156 14.0007L6.28487 8.00102L0.285156 2.0013L1.99936 0.287109L7.99905 6.28684Z" fill="black"/></svg>`

    let cartItemsHTML = data.products.map(product => Array(product.quantity).fill(`<div class="bundle-item"> <div class="bundle-item-content"> <img src="${product.featured_image}" alt="${product.title}" /> <span class="cs-close-icon js-remove-item">${close_icon}</span> </div> </div>`).join("")).join("");
    const limit = data.limit - data.products.reduce((sum, p) => sum + p.quantity, 0);

    if (limit > 0) {
      cartItemsHTML += Array(limit).fill(`<div class="bundle-item empty"> <div class="bundle-item-content"> <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M7.75 7.75V0.25H10.25V7.75H17.75V10.25H10.25V17.75H7.75V10.25H0.25V7.75H7.75Z" fill="black"/> </svg> </div> </div>`).join("");
    }
    bundleItemsContainer.innerHTML = cartItemsHTML;
  }

  renderPerksCart(data) {
    const perksCart = this.querySelector(".bundle-selection-gift-items");
    if (!perksCart) return;
    const bundleItemsContainer = perksCart.querySelector(".bundle-items");
    bundleItemsContainer.innerHTML = "";
    const products = data.gift_products;
    // console.log(products);
    let cartItemsHTML = products.map(product => Array(product.quantity).fill(`<div class="bundle-item"> <div class="bundle-item-content"> <img src="${product.featured_image}" alt="${product.title}" /> <span class="cs-close-icon js-remove-item">${this.closeSvg}</span> </div> </div>`).join("")).join("");
    const limit = (data.gift_limit || 0) - products.reduce((sum, p) => sum + p.quantity, 0);
    if (limit > 0) {
        cartItemsHTML += Array(limit).fill(`<div class="bundle-item empty"> <div class="bundle-item-content"> <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M7.75 7.75V0.25H10.25V7.75H17.75V10.25H10.25V17.75H7.75V10.25H0.25V7.75H7.75Z" fill="black"/> </svg> </div> </div>`).join("");
    }
    bundleItemsContainer.innerHTML = cartItemsHTML;
}

  handleItemRemoval(itemIndex) {
    const mainBundle = this.closest('main-bundle');
    let currentItem = null;
    let itemPosition = 0;

    for (const product of mainBundle.data.products) {
      itemPosition += product.quantity;
      if (itemIndex < itemPosition) {
        currentItem = product;
        break;
      }
    }

    if (currentItem) {
      const productContainer = mainBundle.querySelector(`.bundle-tab-content.active bundle-product[data-product-id="${currentItem.id}"]`);
      if (productContainer) {
        const quantitySelector = productContainer.querySelector('quantity-selector');
        if (quantitySelector) {
          const quantityInput = quantitySelector.querySelector('.quantity-input');
          const newQuantity = currentItem.quantity - 1;
          quantityInput.value = newQuantity;

          if (newQuantity === 0) {
            quantitySelector.classList.remove('added-to-cart');
          }
        }
      }

      mainBundle.dispatchEvent(
        new CustomEvent('bundle:quantity:changed', {
          detail: {
            product: currentItem,
            quantity: currentItem.quantity - 1
          },
          bubbles: true
        })
      );
    }
  }

  resetNextAndCheckoutLayout(){
    this.checkoutButton.forEach((button) => button.disabled = true);
    this.nextButton.disabled = true;
    const closestFooter = this.closest("bundle-footer");
    if(closestFooter){
      closestFooter.querySelector(".second-step").classList.add("hidden");
      closestFooter.querySelector(".first-step").classList.remove("hidden");
    }
  }

  clearSelection() {
    document.documentElement.dispatchEvent(new CustomEvent("bundle:clear", { detail: { products: [], limit: this.data.limit, quantity: 0 } }));
  }

  clearToInitialStep(){
    const mainBundle = this.closest("main-bundle");
    const closestFooter = this.closest("bundle-footer");
    mainBundle.querySelector(".bundle-products-step-2").classList.add("hidden");
    mainBundle.querySelector(".bundle-products-step-1").classList.remove("hidden");
    closestFooter.querySelector(".bundle-selection-gift-items").classList.add("hidden");
    closestFooter.querySelector(".step-1").classList.remove("hidden");
  }

  secondStep({ currentTarget }){
    this.checkoutButton.forEach((button) => button.disabled = false);  
    const mainBundle = this.closest("main-bundle");
    const closestFooter = this.closest("bundle-footer");
    const currentTotalPrice = mainBundle.data.products.reduce((sum, p) => sum + p.price * p.quantity, 0) / 100;
    const freeGiftRequiredQty = window.bundle_progress_bar_settings.free_gift_product_quantity.totalPrice;
    console.log(currentTotalPrice);
    if(currentTarget.classList.contains("bundle-selection-next")){
      closestFooter.querySelector(".first-step").classList.add("hidden");
      closestFooter.querySelector(".second-step").classList.remove("hidden");
    if(currentTotalPrice >= freeGiftRequiredQty){
        mainBundle.querySelector(".bundle-products-step-1").classList.add("hidden");
        mainBundle.querySelector(".bundle-products-step-2").classList.remove("hidden");  
        closestFooter.querySelector(".bundle-selection-gift-items").classList.remove("hidden");
        closestFooter.querySelector(".step-1").classList.add("hidden");
      }
    } else if(currentTarget.classList.contains("bundle-selection-back")){
      closestFooter.querySelector(".second-step").classList.add("hidden");
      closestFooter.querySelector(".first-step").classList.remove("hidden");
      if(currentTotalPrice >= freeGiftRequiredQty){
        mainBundle.querySelector(".bundle-products-step-2").classList.add("hidden");
        mainBundle.querySelector(".bundle-products-step-1").classList.remove("hidden");
        closestFooter.querySelector(".bundle-selection-gift-items").classList.add("hidden");
        closestFooter.querySelector(".step-1").classList.remove("hidden");
      }
    }
  }

  checkout({ currentTarget }) {
    // if(currentTarget.disabled == false) currentTarget.disabled = true;
    var allProducts = [];
    const freeGiftProductQuantity = window.bundle_progress_bar_settings.free_gift_product_quantity.totalPrice;
    const totalAmount = this.closest("main-bundle").data.products.reduce((sum, p) => sum + p.price * p.quantity, 0) / 100;
    if(freeGiftProductQuantity > 0 && totalAmount >= freeGiftProductQuantity){
      allProducts = [...this.closest("main-bundle").data.products, ...this.closest("main-bundle").data.gift_products];
    } else{
      allProducts = [...this.closest("main-bundle").data.products];
    }
    const selectedGifts = this.closest("main-bundle").data.gift_products;
    const items = allProducts.map((p) => ({
      id: p.variant_id || p.id,
      quantity: p.quantity,
      properties: {
        _source: 'build-a-bundle',
        _bundle_discount_test: 'true',
        _bundle_gift: selectedGifts.some((gift) => (gift.variant_id || gift.id) === (p.variant_id || p.id)) ? 'true' : 'false'
      }
    }));
    let formData = { 'items': items };
    const header = { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(formData) };
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    cart.setActiveElement(document.activeElement);
    const _this = this;
    fetch(`${window.Shopify.routes.root}cart/add.js?sections=${cart.getSectionsToRender().map((section) => section.id).join(",")}`, header)
      .then(response => response.json())
      .then((response) => {
        console.log(response);
        cart.renderContents(response);
        _this.clearSelection();
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      });
  }
}
customElements.define("bundle-footer", BundleFooter);

document.addEventListener('DOMContentLoaded', function () {
  const tabsWrapper = document.querySelector('.bundle-collection-tabs');
  const tabs = document.querySelectorAll('.bundle-collection-tab');

  function scrollTabIntoView(tab) {
    const tabsWrapperRect = tabsWrapper.getBoundingClientRect();
    const tabRect = tab.getBoundingClientRect();

    // Calculate the scroll position needed to center the tab
    const scrollLeft = tab.offsetLeft - (tabsWrapperRect.width / 2) + (tabRect.width / 2);

    // Smooth scroll to the position
    tabsWrapper.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
  }

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      scrollTabIntoView(tab);

      // Optional: update active class
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
    });
  });
});
